import { useCallback } from 'react';
import { Pressable } from 'react-native';
import { useTranslation } from '@betty/i18n';
import { Box, Text, Icon, TextProps } from '@betty/moonlight';
import { StackNavigationProp, useNavigation } from '@betty/navigation';

export type AccountLinkProps = {
  icon: React.ReactNode;
  labelKey: Required<TextProps>['locKey'] | '';
  navigateTo: string;
  path?: string;
  key: string;
};

function AccountLink({ icon, labelKey, navigateTo, path }: AccountLinkProps) {
  const { t } = useTranslation('account');
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const handleAccountLinkPress = useCallback(() => {
    navigation.navigate(navigateTo, path ? { path } : undefined);
  }, [navigateTo, navigation, path]);

  if (!labelKey) {
    return null;
  }

  return (
    <Pressable onPress={handleAccountLinkPress}>
      <Box
        flexDirection="row"
        alignItems="center"
        gap="space-800"
        padding="space-400"
      >
        {icon}
        <Box
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
          flex={1}
        >
          <Text variant="body-m" color="darkSurfacePrimary">
            {t(labelKey)}
          </Text>
          <Icon name="arrowForward" gradient="accentBackground" />
        </Box>
      </Box>
    </Pressable>
  );
}

export default AccountLink;
